import DeleteIcon from '@mui/icons-material/Delete';
import EditIcon from '@mui/icons-material/Edit';
import { Button, Card, CardActions, CardContent, CardMedia, Typography } from '@mui/material';
import { imageURL } from 'Config/endpoints';
import { useMutation, useQuery } from 'react-query';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { deleteEventFn, getEventFn } from 'Services/Event';
import moment from 'moment';

const Event = () => {
    const navigate = useNavigate();

    const { data: getEventResponse, refetch } = useQuery({
        queryKey: "get-events",
        queryFn: getEventFn
    });

    const { mutate: deleteEvent } = useMutation(deleteEventFn, {
        onSuccess: (response) => {
            toast.success("Deleted Successfully");
            refetch();
        }
    });

    const deleteHandle = (id) => {
        const formData = new FormData();
        formData.append("event_id", id);
        deleteEvent(formData);
    };

    return (
        <div className="p-4">
            <div className="flex justify-between items-center mb-4">
                <Typography variant="h5" component="h2" className='!text-black font-bold'>
                    Events
                </Typography>
                <Button
                    variant="contained"
                    onClick={() => navigate(`/event/add`)}
                >
                    Add Event
                </Button>
            </div>

            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
                {getEventResponse?.data?.data?.data?.map((item) => (
                    <Card key={item.id} className="bg-white shadow-lg rounded-lg">
                        <CardMedia
                            component="img"
                            style={{ height: '200px', objectFit: 'cover' }}
                            image={imageURL(item.image)}
                            alt={item.title}
                        />
                        <CardContent>
                            <Typography
                                variant="h6"
                                component="div"
                                className="mb-2 line-clamp-2"
                            >
                                {item.title}
                            </Typography>
                            {item?.description &&
                                <Typography
                                    variant="body2"
                                    color="textSecondary"
                                    className="line-clamp-3"
                                    dangerouslySetInnerHTML={{ __html: item?.description }}
                                />
                            }
                            <Typography
                                variant="body2"
                                color="textSecondary"
                                className="mt-2"
                            >
                                <strong>Location:</strong> {item.location}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                            >
                                <strong>Start Date:</strong> {moment(item.start_date).format('MMM DD, YYYY')}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                            >
                                <strong>End Date:</strong> {moment(item.end_date).format('MMM DD, YYYY')}
                            </Typography>
                            <Typography
                                variant="body2"
                                color="textSecondary"
                            >
                                <strong>Created At:</strong> {moment(item.created_at).format('MMM DD, YYYY')}
                            </Typography>
                            {item?.link &&
                                <a
                                    className='text-green-600 text-sm underline'
                                    href={item?.link}
                                    target='_blank' rel="noreferrer"
                                >
                                    Link
                                </a>
                            }
                        </CardContent>
                        <CardActions>
                            <Button
                                size="small"
                                color="primary"
                                onClick={() => navigate(`/event/update/${item?.id}`)}
                            >
                                <EditIcon />
                                Update
                            </Button>
                            <Button
                                size="small"
                                color="error"
                                onClick={() => deleteHandle(item.id)}
                            >
                                <DeleteIcon />
                                Delete
                            </Button>
                        </CardActions>
                    </Card>
                ))}
            </div>
        </div>
    );
};

export default Event;
